import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getToken = () => {
  return localStorage.getItem("accessToken");
};

export const refreshToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      toast.error("You have been logged out, please log in again.");
      return null;
    }

    const response = await axios.post(`${baseUrl}/auth/refresh/token`, {
      refreshToken: refreshToken,
    });

    const { accessToken } = response.data.data;
    localStorage.setItem("accessToken", accessToken);
    return accessToken;
  } catch (error) {
    console.error("Error refreshing token:", error);
    return null;
  }
};

export const logout = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    // Attempt to notify backend; don't block on failure
    const url = `${baseUrl}/auth/logout`;
    const headers = {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      "Content-Type": "application/json",
    };

    const payload = refreshToken ? { refreshToken } : undefined;

    const response = await axios.post(url, payload, { headers });
    return response.data;
  } catch (error) {
    // If logout request fails, still clear client-side session
    console.warn("Logout request failed:", error?.message || error);
  } finally {
    // Clear stored tokens and user info locally
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
  }
};
